<template>
  <div id="trafficMagtIndex" class="containerWarp">
    <!-- 筛选 -->
    <div class="searchWarp">
      <!-- <el-select v-model="searchObj.companyId" :placeholder="$t('BondOrUpdateDevice.OwnedCompany')" class="filter-item tableSelect" clearable filterable @change="changeSearch">
        <el-option v-for="(item,index) in companyOptions" :key="index" :label="item.companyName" :value="item.companyId" />
      </el-select> -->
      <SearchCompany v-model="selectCompany2" :value="selectCompany2" @change="changeSearch" />
      <el-select v-model="searchObj.status" :placeholder="$t('AllDevices.Status')" class="filter-item tableSelect"
        clearable filterable @change="changeSearch">
        <el-option v-for="(item,index) in statusOptions" :key="index" :label="item.label" :value="item.value" />
      </el-select>
      <el-input v-model="searchObj.orderSn" :placeholder="$t('sim.orderNumber')" class="input-with-select tableSelect"
        clearable @clear="changeSearch">
        <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
      </el-input>
    </div>
    <!-- 表格 -->
    <el-table id="feedBackTable" v-loading="loading" :data="tableList" style="width: 100%" border fit
      highlight-current-row>
      <!-- <el-table-column type="expand">
        <template slot-scope="scope">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-col :xs="12" :sm="12" :lg="8">
              <el-form-item :label="$t('sim.auditTime')">
                <span>{{ scope.row.auditTimeZh }}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="12" :lg="8">
              <el-form-item :label="$t('sim.auditUser')">
                <span>{{ scope.row.auditUser||'--' }}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="12" :lg="8">
              <el-form-item :label="$t('sim.contactInfo')">
                <span>{{ scope.row.contactInfo||'--' }}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="12" :lg="8">
              <el-form-item :label="$t('sim.payupdateTime')">
                <span>{{ scope.row.updateTimeZh }}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="12" :lg="8">
              <el-form-item :label="$t('warningPage.Remark')">
                <span>{{ scope.row.remark ||'--' }} </span>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="12" :lg="8">
              <el-form-item :label="$t('sim.payAccount')">
                <span>{{ scope.row.paymentAccount }}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="12" :lg="8">
              <el-form-item :label="$t('sim.payer')">
                <span>{{ scope.row.userName }}</span>
              </el-form-item>
            </el-col>
          </el-form>
        </template>
      </el-table-column> -->
      <el-table-column prop="orderSn" :label="$t('sim.orderNumber')" align="center">
        <template slot-scope="scope">
          <div style="text-align: center;">
            <el-link style="margin-right: 10px;" type="primary"
              @click="goToDetail(scope.row,scope.$index)">{{ scope.row.orderSn }}</el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="deviceCompanyName" :label="$t('AllDevices.companyName')" align="center"
        show-overflow-tooltip min-width="100px">
        <template slot-scope="scope">
          <div class="tableCellHidePop">
            <span>{{ scope.row.deviceCompanyName }}</span>
          </div>

        </template>
      </el-table-column>
      <el-table-column prop="price" :label="$t('sim.Currency')" align="center">
        <template slot-scope="scope">
          <div style="text-align: center;">
            <p v-if="scope.row.currency==1">{{ $t('sim.RMB') }}</p>
            <p v-else>{{ $t('sim.Dollar') }}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="price" :label="$t('sim.Price')" align="center">
        <template slot-scope="scope">
          <span style="color:green">¥ {{ scope.row.priceTotal }}</span>
          <span style="color:blue">$ {{ scope.row.priceUsdTotal }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="years" :label="$t('sim.YearsPurchase')" align="center" width="60" />
      <!-- <el-table-column prop="paymentAccount" :label="$t('sim.payAccount')" align="center" />
      <el-table-column prop="userName" :label="$t('sim.payer')" align="center" /> -->
      <el-table-column prop="createTimeZh" :label="$t('adminView.Created')" align="center" />
      <el-table-column prop="ExpirationZh" :label="$t('allDeviceDetail.Expiration')" align="center" />
      <el-table-column :label="$t('AllDevices.Status')" align="center" prop="statusZh">
        <template slot-scope="scope">
          <!-- <div style="text-align: center;" class="basinfoStatu" :class="{'loading':scope.row.loading}">
            <el-popover v-if="scope.row.status==0||scope.row.status==1||scope.row.status==2" v-model="scope.row.showPopover" :disabled="scope.row.loading" placement="bottom" width="auto" trigger="click" :popper-class="'statuPop'+scope.$index">
              <div>
                <div v-for="(item,index) in statusOptions" :key="index" class="statusOption">
                  <p v-if="(item.value>=scope.row.status||(item.value==1&&scope.row.status==2))&&item.canSelect" class="statuSelect" :class="{'activeStatu':item.isActive}" @click="selectStatu(scope.$index,item.value)">{{ item.label }}</p>
                  <div v-if="item.isActive" class="el-icon-success" />
                </div>
                <div slot="footer" class="dialog-footer" style="text-align: center;margin-top:10px;">
                  <el-button class="filter-item" type="primary" :disabled="scope.row.status==scope.row.editStatus" @click="submitEdit(scope.row.orderSn,scope.row.editStatus,scope.$index)">{{ $t('button.Submit') }}</el-button>
                </div>
              </div>
              <div slot="reference" :class="{'doing':scope.row.status==0||scope.row.status==1||scope.row.status==2}">
                {{ scope.row.statusZh }}
                <i v-if="scope.row.loading" class="el-icon-loading" />
              </div>
            </el-popover>
            <div v-else :class="{'overTime':scope.row.status==4,'done':scope.row.status==3}">
              {{ scope.row.statusZh }}
            </div>
          </div> -->
          <!-- <div class="tableStatu" :class="[{'doing':scope.row.status==0||scope.row.status==1||scope.row.status==2},{'overTime':scope.row.status==4,'done':scope.row.status==3}]" @click="clickStatu(scope.row,scope.$index)"> -->
          <div class="tableStatu"
            :class="[{'doing':scope.row.status==0||scope.row.status==1||scope.row.status==2},{'overTime':scope.row.status==4,'done':scope.row.status==3}]">
            {{ scope.row.statusZh }}
            <i v-if="scope.row.loading" class="el-icon-loading" />
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 列表模块————分页 -->
    <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
      <div class="pagination-container">
        <el-pagination v-if="pageshow" background current-page.sync="listQuery.pageInfo.page"
          :page-sizes="listQuery.pageInfo.pageList" :page-size="listQuery.pageInfo.limit"
          layout="total, sizes, prev, pager, next, jumper" :total="listQuery.pageInfo.total"
          @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </div>

    <el-dialog :close-on-click-modal="false" :visible.sync="orderDetailPop" width="80%" class="configStatuPop"
      top="5vh">
      <orderMagtDetail :order-detail-pop="orderDetailPop" @cancelPop="cancelPop" />
    </el-dialog>

    <!-- 状态弹窗 -->
    <el-dialog :close-on-click-modal="false" class="orderMagtStatuPop statusPop" width="70%"
      :visible.sync="isShowStautPop">
      <div>
        <p class="blockTitleP" style="margin-top: -50px;width: calc(100% - 50px)"> {{ $t('adminView.Edit') }}
          {{ $t('AllDevices.Status') }}</p>
        <el-form :model="currentOrder" label-position="right" label-width="150px">
          <!-- <p>{{ currentOrder.status }}-{{ currentOrder.newStatus }}</p> -->
          <el-form-item :label="$t('AllDevices.Status')">
            <el-select v-model="currentOrder.newStatus" :placeholder="$t('button.select')" @change="change">
              <el-option v-for="item in filterStatusOptions" :key="item.value" :label="item.label"
                :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('warningPage.Remark')">
            <el-input v-model="currentOrder.auditRemark" :autosize="{ minRows: 4, maxRows: 8}"
              :placeholder="$t('warningSet.Pleaseenter')" style="width: 80%" type="textarea" />
          </el-form-item>
          <el-form-item :label="$t('sim.uploadFiles')">
            <div class="imgWarp">
              <el-upload class="upload-demo" :action="action" :on-preview="handlePreview"
                :headers="{token: $store.state.token}" name="multipartFile" :on-remove="handleRemove"
                :on-success="successUpload" multiple :limit="3" :on-exceed="handleExceed" :file-list="fileList">
                <el-button size="small" type="primary">{{ $t('QR.SelectFile') }}</el-button>
                <div slot="tip" class="el-upload__tip">{{ $t('sim.fileInfo') }}</div>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center;">
          <el-button @click="isShowStautPop = false">{{ $t('button.Cancel') }}</el-button>
          <el-button class="filter-item" :disabled="currentOrder.status==currentOrder.newStatus" type="primary"
            @click="submitEdit(currentOrder.orderSn)">{{ $t('button.Submit') }}</el-button>
        </div>
        <p class="blockTitleP" style="margin:10px 0 0 -10px;border-top: 1px solid #dcdfe6;">{{ $t('sim.lifeCycle') }}
        </p>
        <div class="baseContentWarp" style="padding-left: 10px;">
          <p v-if="statuList.length==0" style="text-align: center;">{{ $t('yhubReport.Nodata') }}</p>
          <div class="stepsWarp">
            <div v-for="(item,index) in statuList" :key="index" class="stepDiv"
              :class="[{'active':currentOrder.status==item.statu},{'done':currentOrder.status>item.statu},{'next':currentOrder.status<item.statu}]">
              <p class="title">{{ item.title }}</p>
              <p class="numBox">
                <span class="leftLine line" />
                <span class="num">
                  <span v-if="currentOrder.status>=item.statu" class="el-icon-check" />
                  <span v-else>{{ item.statu+1 }}</span>
                </span>
                <span class="rightLine line" />
              </p>
              <p class="time">{{ item.time }}</p>
              <p class="description">{{ item.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { pageDataServiceOrder, updateDataServiceOrderStatus } from '@/api/sim'
import { pagination } from '@/utils/init_table' // 分页
import i18n from '@/i18n'
import { getDateAndHour } from '@/utils/updateTime.js'
import orderMagtDetail from './orderMagtDetail'
export default {
  components: {
    orderMagtDetail
  },
  data () {
    return {
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end
      searchObj: {
        orderSn: null,
        status: null,
        companyId: ''
      },
      selectDayWarning: [],
      companyOptions: [],
      tableList: [],
      loading: true,
      statusOptions: [// 状态：0未支付待审核、1待支付、2已支付待审核、3支付成功、4过期失效
        { label: i18n.t('sim.unpaidReview'), value: 0 },
        { label: i18n.t('sim.PendingPay'), value: 1 },
        { label: i18n.t('sim.review'), value: 2 },
        { label: i18n.t('sim.PaySuccess'), value: 3 },
        { label: i18n.t('sim.ExpirationExpired'), value: 4 }
      ],
      orderDetailPop: false,
      selectCompany: [],
      selectCompany2: [],
      isShowStautPop: false,
      currentOrder: {
        newStatus: null,
        auditRemark: null
      },
      filterStatusOptions: [],
      fileList: [],
      action: '#',
      statuList: []
    }
  },
  computed: {
    language () {
      return this.$store.state.language
    }
  },
  watch: {
    language (newValue, oldValue) {
      this.initTable()
      this.statusOptions.forEach(v => {
        switch (v.value) {
          case 0: v.label = i18n.t('sim.unpaidReview'); break// 未支付待审核
          case 1: v.label = i18n.t('sim.PendingPay'); break// 已审核待支付
          case 2: v.label = i18n.t('sim.review'); break// 已支付待审核
          case 3: v.label = i18n.t('sim.PaySuccess'); break// 支付成功
          case 4: v.label = i18n.t('sim.ExpirationExpired'); break// 过期失效
        }
      })
    }
  },
  mounted () {
    this.statusOptions.forEach(v => {
      v.canSelect = true
    })
    this.statusOptions = [...this.statusOptions]
    this.initTable()// 获取列表
  },
  methods: {
    clickStatu (row, index) { // 打开状态弹窗
      this.action = process.env.VUE_APP_BASE_API + '/v3/manager/commUpload/upload/dataService'
      this.currentOrder = row
      this.currentOrder.index = index
      this.currentOrder.newStatus = this.currentOrder.status
      this.isShowStautPop = true
      this.filterStatusOptions = []
      this.fileList = []
      console.log('row', row)
      var auditFileArr = row.auditFile ? row.auditFile.split('/,') : []
      auditFileArr.forEach(v => { // 处理文件
        var fileInfo = v.split('?name=') || ['', '']
        this.fileList.push({ name: fileInfo[1], url: fileInfo[0] })
      })
      this.statusOptions.forEach(v => { // 处理状态下拉框
        if (this.currentOrder.status == 0 || this.currentOrder.status == 1 || this.currentOrder.status == 2) {
          if (v.value >= this.currentOrder.status || (v.value == 1 && this.currentOrder.status == 2)) {
            // 已支付待审核(2) 没有 过期失效(4) 选项
            // if (this.currentOrder.status != 2 && v.value != 4) this.filterStatusOptions.push(v)
            if (v.value != 4) {
              this.filterStatusOptions.push(v)
            } else {
              if (this.currentOrder.status != 2) this.filterStatusOptions.push(v)
            }
          }
        } else {
          if (v.value == this.currentOrder.status) {
            this.filterStatusOptions.push(v)
          }
        }
      })
      this.statuList = []
      this.statuList.push(
        { statu: 0, title: this.$t('sim.unpaidReview'), time: row.createTime ? getDateAndHour(row.createTime, 'noSecond') : '--', description: row.createUser },
        { statu: 1, title: this.$t('sim.PendingPay'), time: row.notPaidTime ? getDateAndHour(row.notPaidTime, 'noSecond') : '--', description: row.notPaidUser },
        { statu: 2, title: this.$t('sim.review'), time: row.paidTime ? getDateAndHour(row.paidTime, 'noSecond') : '--', description: row.paidUser },
        { statu: 3, title: this.$t('sim.PaySuccess'), time: row.auditTime ? getDateAndHour(row.auditTime, 'noSecond') : '--', description: row.auditUser },
      )
      if (this.currentOrder.status == 4) {
        this.statuList.push(
          { statu: 4, title: this.$t('sim.ExpirationExpired'), time: row.updateTime ? getDateAndHour(row.updateTime, 'noSecond') : '--', description: '' },
        )
      }
    },
    handleRemove (file, fileList) { // 删除文件
      console.log(file, fileList)
      this.fileList = fileList
    },
    handlePreview (file) { // 文件预览
      console.log(file)
      window.open(file.url, '_blank')
    },
    handleExceed (files, fileList) {
      this.$message.warning(this.$t('sim.fileInfo2'))
    },
    successUpload (res, file) { // 文件上传成功
      console.log(res, file)
      this.fileList.push({ name: file.name, url: file.response.resultModel })
    },
    change () {
      this.$forceUpdate()
    },
    initTable () { // 初始化列表
      this.loading = true
      var param = {
        'companyIdList': this.selectCompany,
        'orderSn': this.searchObj.orderSn,
        'status': this.searchObj.status,
        'pageNum': this.listQuery.pageInfo.pageNum,
        'pageSize': this.listQuery.pageInfo.pageSize
      }
      pageDataServiceOrder(param).then(res => {
        this.loading = false
        if (res.resultCode == 1001) {
          this.listQuery.pageInfo.total = res.resultModel.total // 分页
          var list = res.resultModel.list || []
          list.forEach(v => {
            v.isView = true
            v.showPopover = false
            v.loading = false
            v.createTimeZh = v.createTime ? getDateAndHour(v.createTime, 'noSecond') : '--'
            v.ExpirationZh = (v.createTime && v.status == 1) ? getDateAndHour(v.createTime + 7 * 24 * 60 * 60 * 1000, 'noSecond') : '--'
            v.auditTimeZh = v.auditTime ? getDateAndHour(v.auditTime, 'noSecond') : '--'
            v.updateTimeZh = v.updateTime ? getDateAndHour(v.updateTime, 'noSecond') : '--'
            this.statusOptions.forEach(m => {
              if (v.status == m.value) {
                v.statusZh = m.label
              }
            })
            var arr = JSON.parse(v.detail) || []
            v.deviceCompanyName = ''
            arr.forEach((m, index) => {
              if (v.deviceCompanyName.indexOf(m.companyName) > -1) return
              v.deviceCompanyName += m.companyName + ','
            })
            if (v.deviceCompanyName.slice(v.deviceCompanyName.length - 1) == ',') v.deviceCompanyName = v.deviceCompanyName.slice(0, v.deviceCompanyName.length - 1)
          })
          this.tableList = list
        }
      })
    },
    submitEdit (orderSn, editStatus) { // 列表中改状态--提交
      var param = {
        orderSn: orderSn,
        status: this.currentOrder.newStatus,
        auditRemark: this.currentOrder.auditRemark,
        auditFile: ''
      }
      this.fileList.forEach((v, index) => { // 将文件名和url都保存,文件间用 /， 分隔
        if (index < this.fileList.length - 1) { param.auditFile += v.url + '?name=' + v.name + '/,' } else { param.auditFile += v.url + '?name=' + v.name }
      })
      // console.log('this.fileList--', this.fileList)
      // console.log('this.param--', param)
      this.$confirm(i18n.t('sim.sureChange'), '', {
        confirmButtonText: i18n.t('button.Confirm'),
        cancelButtonText: i18n.t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        this.tableList[this.currentOrder.index].loading = true
        console.log('submitEdit:index', this.currentOrder.index)
        updateDataServiceOrderStatus(param).then(res => {
          this.tableList[this.currentOrder.index].loading = false
          if (res.resultCode == 1001) {
            this.isShowStautPop = false
            this.$message({
              type: 'success',
              message: this.$t('warningSet.submitted')
            })
            this.initTable()// 获取列表
          } else {
            this.$notify({
              message: res.resultMessage,
              type: 'warning',
              duration: 2000
            })
          }
        })
      }).catch(() => {

      })
    },
    goToDetail (row, index) {
      // var routeData = this.$router.resolve({
      //   path: '/sim/orderDetail',
      //   query: {
      //     mcuId: row.orderSn
      //   }
      // })
      row.index = index
      this.orderDetailPop = true
      sessionStorage.setItem('orderMagtRow', JSON.stringify(row))
      // window.open(routeData.href, '_self')
    },
    changeSearch () {
      this.selectCompany = []
      this.selectCompany2.forEach(v => {
        this.selectCompany.push((typeof v === 'string' && v.indexOf('ID') > -1) ? v.slice(2) : v)
      })
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.initTable()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    handleSizeChange (val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.initTable()
    },
    handleCurrentChange (val, e) { // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.initTable()
    },
    cancelPop () {
      this.orderDetailPop = false
      this.initTable()
    }
  }
}
</script>

<style lang="scss">
#trafficMagtIndex {
  .searchWarp {
    margin-bottom: 20px;
    display: flex;
    position: relative;
    .tableSelect {
      width: 20%;
    }
  }
  .tableStatu {
    // cursor: pointer;
    &.doing,
    &.done,
    &.overTime {
      padding: 6px 20px;
      display: inline-block;
      line-height: 14px;
      border-radius: 15px;
      // cursor: pointer;
    }
    &.doing {
      color: #1990fc;
      //border: 1px solid #1990fc;
      // cursor: pointer;
    }
    &.done {
      color: green;
      //border: 1px solid green;
      // cursor: default;
    }
    &.overTime {
      color: #aaadb4;
      //border: 1px solid #aaadb4;
      // cursor: default;
    }
  }
  .statuInp {
    width: calc(100% - 70px);
    margin-right: 10px;
  }
  .statuSelect {
    margin-right: 10px;
    width: calc(100% - 140px);
  }
}
.el-popper {
  .statuSelect {
    display: inline-block;
    line-height: 26px;
    border-radius: 10px;
    cursor: pointer;
    color: #aaadb4;
    border: 1px solid #aaadb4;
    margin-bottom: 10px;
    width: 150px;
  }
  .activeStatu {
    color: #1990fc;
    border: 1px solid #1990fc;
  }
  .disabledSelect {
    cursor: not-allowed;
  }
  .statusOption {
    position: relative;
    text-align: center;
  }
  .el-icon-success {
    color: #1990fc;
    position: absolute;
    right: 3px;
    top: -5px;
    background: #fff;
    font-size: 18px;
  }
}
.loading {
  .doing {
    position: relative;
    cursor: not-allowed !important;
    color: #1990fc7d !important;
    border-color: #1990fc7d !important;
  }
  .el-icon-loading {
    position: absolute;
    right: 5px;
    font-size: 13px;
  }
}

.stepsWarp {
  display: flex;
  .stepDiv {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
    padding: 0 60px;
    overflow: hidden; //超出隐藏
    text-overflow: ellipsis; //显示...
    white-space: nowrap; //文本不换行
  }
  .numBox {
    width: 100%;
    display: flex;
    align-items: center;
    .num {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 2px solid #999;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .line {
      display: inline-block;
      width: calc(50% - 12px);
      border-top: 2px solid #99999930;
    }
    .leftLine {
      margin-right: 2px;
    }
    .rightLine {
      margin-left: 2px;
    }
    .el-icon-check {
      color: green;
    }
  }
  .done {
    .line,
    .num {
      border-color: green;
    }
  }
  .active {
    .leftLine,
    .num {
      border-color: green;
    }
    .title {
      color: green;
    }
  }
  .time {
    margin: 5px 0 3px;
  }
  .stepDiv:nth-of-type(1) {
    .leftLine {
      border-color: transparent;
    }
  }
  .stepDiv:nth-last-of-type(1) {
    .rightLine {
      border-color: transparent;
    }
  }
}
</style>
<style lang="scss">
.orderMagtStatuPop {
  .upload-demo {
    width: 80%;
    .el-icon-close-tip {
      display: none !important;
    }
  }
}
.deviceCompanyNameBox {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
  width: 100%;
}
</style>
